import {Fragment} from "react";
import {PlanFeatureProvider} from '~/contexts/PlanFeatureContext';
import 'react-toastify/dist/ReactToastify.css';
function AIChatbotChatLayout({children })  {
    return (
        <PlanFeatureProvider>
            <main className='main'>
                {children}
            </main>
        </PlanFeatureProvider>
    )
}
export default AIChatbotChatLayout;